import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Wrapper = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
  }),
);

export const VelodromeName = styled.span(() =>
  mq({
    fontSize: defaultTheme.font.size.xl,
    fontWeight: 'bold',
    lineHeight: defaultTheme.font.height.base,
    marginRight: defaultTheme.spacing.s,
  }),
);

export const Icons = styled.div(() =>
  mq({
    marginRight: defaultTheme.spacing.s,
  }),
);

export const VelodromeLink = styled(Link)(() =>
  mq({
    textDecorationLine: 'underline',
    ...hoverOpacity,
  }),
);
